import React, { type ComponentType } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect';

// This component will redirect users to the old route if the feature flag is disabled.
export default function withRedirectToOld(Component: ComponentType, metricKey: string) {
	return () => {
		if (ff('split-metric-detail-routes-from-1-to-3_9hlcc')) {
			return <Component />;
		}

		return <ScreenRedirect to={`/jira/settings/system/performance/metric/${metricKey}`} />;
	};
}
